const FilterModel = []

export default FilterModel
